export const STATUS = {
  WAITING: -1,
  TIMEOUT: 0,
  ACTIVE: 100,
  SUCCESS: 200,
  FAIL: 400,
  NOT_FOUND: 404,
  HUBLET_REDIRECT: 488,
  SERVER_ERROR: 500
};